module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "dedication",
    attrs: {
      "epub:type": "dedication"
    }
  }, [_c('p', {
    staticClass: "no_header firstInSection"
  }, [_c('em', [_vm._v("For all their steadfast love and support, my thoughts go out to my two lovely sisters, Winifred and Anita.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Life hasn’t been easy for them, but they can always find a smile, bless their hearts.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Not forgetting my seven brothers, Sonny, Joseph, Bernard, Richard, Billy, Harry and Alec.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("They could never be described as angels, but our late lovely Mam would have been as proud of them all as I am. (Keep the meat an’ tater pies hot, lads!)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 66
// module chunks = 0